import $ from 'jquery';

const faq = function faq() {
  const $faqToggle = $('.faq-item__toggle');

  $faqToggle.click(ev => {
    const $self = $(ev.target);
    $self.toggleClass('active');
    const $content = $self.next();
    $content.slideToggle();
  });
};
export default faq;



// WEBPACK FOOTER //
// ./src/scripts/modules/faq.js